import { t } from "../../i18n";
import type { LocalMcpEditorValue } from "./McpEditor.types";

export function McpBasicFields({
  value,
  onChange,
  disabled = false,
  inputClassName = "field",
  labelClassName = "label",
}: {
  value: Pick<LocalMcpEditorValue, "name" | "description">;
  onChange: (value: Pick<LocalMcpEditorValue, "name" | "description">) => void;
  disabled?: boolean;
  inputClassName?: string;
  labelClassName?: string;
}) {
  return (
    <>
      <label>
        <span className={labelClassName}>{t("Name")}</span>
        <input
          className={inputClassName}
          value={value.name}
          onChange={(event) => onChange({ ...value, name: event.target.value })}
          disabled={disabled}
        />
      </label>
      <label>
        <span className={labelClassName}>{t("Description")}</span>
        <input
          className={inputClassName}
          value={value.description}
          onChange={(event) =>
            onChange({ ...value, description: event.target.value })
          }
          disabled={disabled}
        />
      </label>
    </>
  );
}
